import { render, staticRenderFns } from "./UserOrder.vue?vue&type=template&id=6dbe8c66&scoped=true&"
import script from "./UserOrder.vue?vue&type=script&lang=js&"
export * from "./UserOrder.vue?vue&type=script&lang=js&"
import style0 from "./UserOrder.vue?vue&type=style&index=0&id=6dbe8c66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe8c66",
  null
  
)

export default component.exports